import {
  Commission,
  Organization,
  adspCommission,
  bdspCommission,
  AdServiceFee,
  tdspCommission,
} from "./user";

export const getDateRangeOptions = [
  { label: "Today", value: "today" },
  { label: "Yesterday", value: "yesterday" },
  { label: "Last 7 days", value: "last_7_days" },
  { label: "Month to date", value: "month_to_date" },
  { label: "Last 30 days", value: "last_30_days" },
];

export const getBDSPDateRangeOptions = [
  { label: "Today", value: "today" },
  { label: "Yesterday", value: "yesterday" },
  { label: "Last 7 days", value: "last_7_days" },
  { label: "Month to date", value: "month_to_date" },
  { label: "Last 30 days", value: "last_30_days" },
];

export const getADSPDateRangeOptions = [
  { label: "Today", value: "today" },
  { label: "Yesterday", value: "yesterday" },
  { label: "Last 7 days", value: "last_7_days" },
  { label: "Month to date", value: "month_to_date" },
];

export enum UniversalConst {
  DEFAULT_STATS_TIME_PERIOD = "yesterday",
  MIN_RECENCY = 1,
  MAX_RECENCY = 14,
  MIN_FREQ = 1,
  MAX_FREQ_HOUR = 5,
  MAX_FREQ_DAY = 20,
  MAX_FREQ_WEEK = 100,
  MAX_FREQ_MONTH = 200,
  MAX_FREQ_LIFETIME = 255,
  MIN_COMMISSION = 0,
  MAX_COMMISSION = 2000,
  DAILY_BUDGET_MIN_LIMIT = 5,
  freq_cap_Hour_limit = 1,
  Freq_Cap_Day_Limit = 1,
  Freq_Cap_Week_Limit = 1,
  Freq_Cap_Month_Limit = 1,
  Freq_Cap_Lifetime_Limt = 1,
  BDSP_MAX_FREQ_HOUR = 720,
  BDSP_MAX_FREQ_DAY = 30,
  BDSP_MAX_FREQ_WEEK = 4,
  BDSP_MAX_FLAT_CPM = 100,
  BDSP_MIN_MUL = 1,
  BDSP_MAX_MUL = 2,
  ATTR_MIN_CLICK = 1,
  ATTR_MIN_IMP = 1,
  ATTR_MAX_IMP = 30,
  ATTR_MAX_CLICK = 30,
  DEDUP_MIN_CLICK = 1,
  DEDUP_MAX_CLICK = 30,
  DEDUP_MAX_CONV = 60,
  DEDUP_MIN_CONV = 1,
  TDSP_MIN_MARGIN = 0,
  TDSP_MAX_MARGIN = 100,
  TDSP_MAX_FREQ_HOUR = 720,
  TDSP_MAX_FREQ_DAY = 30,
  TDSP_MAX_FREQ_WEEK = 4,
  TDSP_MAX_FLAT_CPM = 100,
  MAX_AGN_COM = 80,
  MIN_AGN_COM = 0
}

export enum PermissionLevel {
  // delete > create > edit > view > list
  DELETE = 5,
  CREATE = 4,
  EDIT = 3,
  VIEW = 2,
  LIST = 1,
}

export const whiteLabelMaxCreditLimit = 10;

export const contractType = {
  initial_msa: "Initial MSA",
  addendum: "Addendum",
  offline_signed_msa: "Offline Signed MSA",
};

export const clientContractStatus = {
  signed: "Accepted",
  pending: "Yet to Accept",
};

export const paymentOptions: Array<any> = [
  { value: "direct_debit", label: "Debit Card" },
  { value: "credit_card", label: "Credit Card" },
  { value: "check", label: "Check" },
  { value: "other", label: "Other" },
];

export const govtLevelOptions: Array<any> = [
  { value: "local_or_state", label: "State or Local" },
  { value: "federal", label: "Federal" },
  { value: "both", label: "Both" },
];

export const booleanOptions: Array<any> = [
  { value: true, label: "Yes" },
  { value: false, label: "No" },
];

export const contractDocTypeOptions: Array<any> = [
  { value: "initial_msa", label: "Initial MSA" },
  { value: "addendum", label: "Addendum" },
  { value: "offline_signed_msa", label: "Offline Signed MSA" },
];

export const clientServiceTypeOptions: Array<any> = [
  { value: "lite", label: "Lite" },
  { value: "advanced_self", label: "Advanced - Self" },
  { value: "advanced_managed", label: "Advanced - Managed" },
  { value: "professional_self", label: "Professional - Self" },
  { value: "professional_managed", label: "Professional - Managed" },
];

export const whiteLabelServiceTypeOptions: Array<any> = [
  { value: "professional_self", label: "Self" },
  { value: "professional_managed", label: "Managed" },
];

export const MsaEntities: Array<any> = ["US"];

export const abc: Array<any> = [1, 1, 1, 1];

export const phoneCode: Array<any> = [
  "+1",
  "+1242",
  "+1246",
  "+1264",
  "+1268",
  "+1284",
  "+1340",
  "+1345",
  "+1441",
  "+1473",
  "+1649",
  "+1664",
  "+1670",
  "+1671",
  "+1684",
  "+1721",
  "+1758",
  "+1767",
  "+1784",
  "+1787",
  "+1808",
  "+1809",
  "+1829",
  "+1 849",
  "+1 868",
  "+1 869",
  "+1876",
  "+1939",
  "+20",
  "+211",
  "+212",
  "+213",
  "+216",
  "+218",
  "+220",
  "+221",
  "+222",
  "+223",
  "+224",
  "+225",
  "+226",
  "+227",
  "+228",
  "+229",
  "+230",
  "+231",
  "+232",
  "+233",
  "+234",
  "+235",
  "+236",
  "+237",
  "+238",
  "+239",
  "+240",
  "+241",
  "+242",
  "+243",
  "+244",
  "+245",
  "+246",
  "+247",
  "+248",
  "+249",
  "+250",
  "+251",
  "+252",
  "+253",
  "+254",
  "+255",
  "+255 24",
  "+256",
  "+257",
  "+258",
  "+260",
  "+261",
  "+262",
  "+262269",
  "+262639",
  "+263",
  "+264",
  "+265",
  "+266",
  "+267",
  "+268",
  "+269",
  "+27",
  "+290",
  "+2908",
  "+291",
  "+297",
  "+298",
  "+299",
  "+30",
  "+31",
  "+32",
  "+33",
  "+34",
  "+350",
  "+351",
  "+352",
  "+353",
  "+354",
  "+355",
  "+356",
  "+357",
  "+358",
  "+35818",
  "+359",
  "+36",
  "+370",
  "+371",
  "+372",
  "+373",
  "+3732",
  "+3735",
  "+374",
  "+37447",
  "+37497",
  "+375",
  "+376",
  "+377",
  "+37744",
  "+37745",
  "+378",
  "+379",
  "+380",
  "+381",
  "+38128",
  "+38129",
  "+38138",
  "+38139",
  "+382",
  "+383",
  "+385",
  "+386",
  "+38643",
  "+38649",
  "+387",
  "+389",
  "+39",
  "+3906698",
  "+40",
  "+41",
  "+420",
  "+421",
  "+423",
  "+43",
  "+44",
  "+441481",
  "+441534",
  "+441624",
  "+4428",
  "+447524",
  "+447624",
  "+447781",
  "+447839",
  "+447911",
  "+447924",
  "+45",
  "+46",
  "+47",
  "+4779",
  "+48",
  "+49",
  "+500",
  "+501",
  "+502",
  "+503",
  "+504",
  "+505",
  "+506",
  "+507",
  "+508",
  "+509",
  "+51",
  "+52",
  "+53",
  "+54",
  "+55",
  "+56",
  "+57",
  "+58",
  "+590",
  "+591",
  "+592",
  "+593",
  "+594",
  "+595",
  "+596",
  "+597",
  "+598",
  "+5993",
  "+5994",
  "+5997",
  "+5999",
  "+60",
  "+61",
  "+6189162",
  "+6189164",
  "+62",
  "+63",
  "+64",
  "+65",
  "+66",
  "+670",
  "+672",
  "+6723",
  "+673",
  "+674",
  "+675",
  "+676",
  "+677",
  "+678",
  "+679",
  "+680",
  "+681",
  "+682",
  "+683",
  "+685",
  "+686",
  "+687",
  "+688",
  "+689",
  "+690",
  "+691",
  "+692",
  "+7",
  "+76",
  "+77",
  "+7840",
  "+7940",
  "+81",
  "+82",
  "+84",
  "+850",
  "+852",
  "+853",
  "+855",
  "+856",
  "+86",
  "+880",
  "+881",
  "+8810",
  "+8812",
  "+8816",
  "+8818",
  "+882",
  "+886",
  "+90",
  "+90392",
  "+91",
  "+92",
  "+93",
  "+94",
  "+95",
  "+960",
  "+961",
  "+962",
  "+963",
  "+964",
  "+965",
  "+966",
  "+967",
  "+968",
  "+970",
  "+971",
  "+972",
  "+973",
  "+974",
  "+975",
  "+976",
  "+977",
  "+98",
  "+992",
  "+993",
  "+994",
  "+995",
  "+99534",
  "+996",
  "+998",
];

export enum UserManagementType {
  "platform_admin" = "managed",
  "account_manager" = "managed",
  "agency_primary_admin" = "self",
  "agency_admin" = "self",
  "agency_user" = "self",
  "advertiser_primary_admin" = "self",
  "advertiser_admin" = "self",
  "advertiser_user" = "self",
  "agency_reporting_user" = "self",
  "advertiser_reporting_user" = "self",
  "managed_advertiser_user" = "managed",
  "managed_agency_user" = "managed",
}
export const accountState: Array<any> = [
  { label: "Active", value: "active" },
  { label: "Inactive", value: "inactive" },
];

export const CreativeLimits: Object = {
  banner: {
    type: ["image/jpeg", "image/jpg", "image/png", "image/gif"],
    size: 1048576,
    maxSize: "1 Mb",
    allowedFiles: "jpeg, jpg, png, gif",
  },
  native_banner: {
    type: ["image/jpeg", "image/jpg", "image/png", "image/gif"],
    size: 512000,
    maxSize: "500 kb",
    allowedFiles: "jpeg, jpg, png, gif",
  },
  native_video: {
    type: ["image/jpeg", "image/jpg", "image/png", "image/gif"],
    size: 307200,
    maxSize: "300 kb",
    allowedFiles: "jpeg, jpg, png, gif",
  },
  video: {
    type: ["video/mp4", "videp/mkv", "video/mov"],
    size: 52428800,
    maxSize: "50 Mb",
    allowedFiles: "mp4, mkv, mov",
  },
  connected_tv: {
    type: ["video/mp4", "videp/mkv", "video/mov"],
    size: 52428800,
    maxSize: "50 Mb",
    allowedFiles: "mp4, mkv, mov",
  },
  audio: {
    type: ["audio/mpeg"],
    size: 10485760,
    maxSize: "10 Mb",
    allowedFiles: "mp3",
  },
  html5: {
    type: [
      "application/zip",
      "application/x-zip-compressed",
      "application/octet-stream",
      "multipart/x-zip",
    ],
    size: 1572864,
    maxSize: "1.5 Mb",
    allowedFiles: "zip",
  },
};

export const managementType: Array<any> = [
  { label: "Self", value: "self" },
  { label: "Managed", value: "managed" },
];

export const Months: Array<any> = [
  { label: "January", value: "1" },
  { label: "February", value: "2" },
  { label: "March", value: "3" },
  { label: "April", value: "4" },
  { label: "May", value: "5" },
  { label: "June", value: "6" },
  { label: "July", value: "7" },
  { label: "August", value: "8" },
  { label: "September", value: "9" },
  { label: "October", value: "10" },
  { label: "November", value: "11" },
  { label: "December", value: "12" },
];

export const AdPlatformOptions = [
  // {
  //   label: "Global Display and Video Inventory",
  //   value: "apnx_dvi",
  //   helperText: "Available across premium websites and apps across the globe.",
  // },
  // {
  //   label: "Premium CTV and OTT Inventory",
  //   value: "apnx_coi",
  //   helperText:
  //     "Available across premium Connected TV and OTT channels across the globe.",
  // },
  // {
  //   label: "Netflix Premium",
  //   value: "apnx_ntp",
  //   helperText: "Available in the US and UK. More countries coming soon.",
  // },
  {
    label: "Global Display and Video Inventory",
    value: "ttd_dvi",
    helperText: "Available across premium websites and apps across the globe.",
  },
  {
    label: "Premium CTV and OTT Inventory",
    value: "ttd_coi",
    helperText:
      "Available across premium Connected TV and OTT channels across the globe.",
  },
  {
    label: "Amazon Prime Video",
    value: "adsp_apv",
    helperText:
      "Available in the US, Mexico, UK, Germany, France, Italy, Spain, Netherlands.",
  },
  {
    label: "Amazon Owned & Operated Inventory",
    value: "adsp_aop",
    helperText:
      "Display and Video inventory available on Amazon properties including Amazon app, Amazon websites, IMDB, Twitch. Available in the US, Mexico, UK, Germany, France, Italy, Spain, Netherlands.",
  },
  {
    label: "Restricted Inventory",
    value: "sen_ctg",
    helperText: "Restricted Global Audiences, Restricted Inventory (Including CTV and OTT)",
  },
];

export class DefaultMethod {
  disabled;
  value;
  view;
  constructor() {
    this.view = false;
  }
}

export const OrganizationTypeOptions = [
  { value: "agency", label: "Agency" },
  { value: "advertiser", label: "Brand" },
];

export const TierOptions = [
  { value: "professional", label: "Professional" },
  { value: "lite", label: "Lite" },
];

export const VerticalOptions = [
  { value: "general", label: "General" },
  { value: "political", label: "Political" },
];

export const DspOptions: Array<Object> = [
  { label: "All", value: "all" },
  { label: "Vizibl DSP", value: "vizibl_dsp" },
  { label: "Beeswax DSP", value: "beeswax_dsp" },
  { label: "Trade Desk DSP", value: "trade_desk_dsp" },
  { label: "Amazon DSP US", value: "amazon_dsp_us" },
  { label: "Amazon DSP EU", value: "amazon_dsp_eu" },
];

export const RolesAndDefaultLandingPage = {
  platform_superadmin: "/platform-admin/",
  finance_user: "/agency",
  platform_admin: "/agency/",
  account_manager: "/agency/",
  agency_primary_admin: "/agency-advertiser/",
  agency_admin: "/agency-advertiser/",
  agency_user: "/agency-advertiser/",
  agency_reporting_user: "/agency-advertiser/",
  advertiser_primary_admin: "/insertion-order/",
  advertiser_admin: "/insertion-order/",
  advertiser_user: "/insertion-order/",
  advertiser_reporting_user: "/report/",
  agency_advertiser_reporting_user: "/report/",
  managed_advertiser_user: "/insertion-order",
  managed_agency_user: "/agency-advertiser/",
  self_read_only_agc_user: "/agency-advertiser/",
  self_read_only_adv_user: "/insertion-order",
};

export const DefaultNav = {
  platform_superadmin: "main_menu",
  finance_user: "main_menu",
  platform_admin: "main_menu",
  account_manager: "main_menu",
  agency_primary_admin: "platform_menu",
  agency_admin: "platform_menu",
  agency_user: "platform_menu",
  agency_reporting_user: "platform_menu",
  agency_advertiser_reporting_user: "platform_menu",
  advertiser_primary_admin: "advertiser_menu",
  advertiser_admin: "advertiser_menu",
  advertiser_user: "advertiser_menu",
  advertiser_reporting_user: "advertiser_menu",
  platform_account_user: "main_menu",
  managed_advertiser_user: "advertiser_menu",
  managed_agency_user: "platform_menu",
  self_read_only_agc_user: "platform_menu",
  self_read_only_adv_user: "advertiser_menu",
};

export class Profile {
  msa_date;
  msa_id;
  vertical;
  tier;
  organization: Organization;
  currency;
  vdsp_commission: Commission;
  adsp_us_commission: adspCommission;
  adsp_eu_commission: adspCommission;
  bdsp_commission: bdspCommission;
  tdsp_commission: tdspCommission;
  vdsp_ad_serve_fee: AdServiceFee;
  adsp_us_ad_serve_fee: AdServiceFee;
  adsp_eu_ad_serve_fee: AdServiceFee;
  bdsp_ad_serve_fee: AdServiceFee;
  tdsp_ad_serve_fee: AdServiceFee;
  timezone;
  constructor() {
    this.organization = new Organization();
    this.vdsp_commission = new Commission();
    this.adsp_us_commission = new adspCommission();
    this.adsp_eu_commission = new adspCommission();
    this.bdsp_commission = new bdspCommission();
    this.tdsp_commission = new tdspCommission();
    this.vdsp_ad_serve_fee = new AdServiceFee();
    this.adsp_us_ad_serve_fee = new AdServiceFee();
    this.adsp_eu_ad_serve_fee = new AdServiceFee();
    this.bdsp_ad_serve_fee = new AdServiceFee();
    this.tdsp_ad_serve_fee = new AdServiceFee();
  }
}

export const API_SPEC_URL =
  "https://vizibl-test-assets.s3.amazonaws.com/vizibl/Vizibl_API-v2.pdf";

export const TDSP_API_SPEC_URL =
  "https://vizibl-test-assets.s3.us-east-1.amazonaws.com/vizibl/Global+Inventory+API+v2.pdf";

export const VDSP_AGN_ONBOARDING_GUIDE_URL =
  "https://vizibl-test-assets.s3.amazonaws.com/vizibl/Vizibl+Agency+Onboarding+Guide+v1.0.pdf";

export const VDSP_AGN_HELPER_GUIDE_URL =
  "https://vizibl-test-assets.s3.amazonaws.com/vizibl/VDSP+Help+-+Agencies+v3.0.pdf";

// Placeholder constant for Advertiser onboarding guidelines
export const ADV_ONBOARDING_GUIDE_URL = "https://vizibl-test-assets.s3.us-east-1.amazonaws.com/vizibl/Vizibl+Amazon+DSP+Policies+(Details)+v1.pdf";

export const VDSP_ADV_HELPER_GUIDE_URL =
  "https://vizibl-test-assets.s3.amazonaws.com/vizibl/VDSP+Help+-+Advertisers+v3.0.pdf";

export const VDSP_CREATIVE_MACROS_GUIDE_URL =
  "https://vizibl-test-assets.s3.us-east-1.amazonaws.com/vizibl/VDSP+Creative+Macros+01-Apr-25.pdf";

export const AGN_ONBOARDING_GUIDE_GLOBAL_URL =
  "https://vizibl-test-assets.s3.us-east-1.amazonaws.com/vizibl/Global+Agency+Onboarding+Guide+v1.0.pdf";

export const ADV_ONBOARDING_GUIDE_GLOBAL_URL =
  "https://vizibl-test-assets.s3.us-east-1.amazonaws.com/vizibl/Global+Advertiser+Onboarding+Guide+v1.0.pdf";

export const GLOBAL_ADV_HELPER_GUIDE_URL =
  "https://vizibl-test-assets.s3.us-east-1.amazonaws.com/vizibl/Global+Help+-+Advertisers.pdf";

export const GLOBAL_AGN_HELPER_GUIDE_URL =
  "https://vizibl-test-assets.s3.us-east-1.amazonaws.com/vizibl/Global+Help+-+Agency.pdf";

export const ADSP_POLICIES_GUIDE_URL = "https://vizibl-test-assets.s3.us-east-1.amazonaws.com/vizibl/Vizibl+Amazon+DSP+Policies+(Details)+v1.pdf";

export const SUB_PATH = ["adsp", "bdsp", "tdsp", "dco"];

export const CONTEXTUAL_CATEGORY_TEMPLATE_URL = "https://vizibl-test-assets.s3.us-east-1.amazonaws.com/vizibl/contexual_template_global.csv";

export const campaignStateOptions: Array<any> = [
  { label: "Active", value: "active" },
  { label: "Inactive", value: "inactive" },
];

export const API_ROLES: ReadonlySet<string> = new Set([
  "agency_api_user",
  "advertiser_api_user",
]);

export const MGN_SERVE_ROLES: ReadonlySet<string> = new Set([
  "managed_advertiser_user",
  "managed_agency_user",
]);

export const MGN_ROLES_MAPPING = {
  managed_advertiser_user: "Managed Serve Advertiser User",
  managed_agency_user: "Managed Serve Agency User",
};

export const READ_ONLY_ROLES = new Set<any>([
  "self_read_only_agc_user",
  "self_read_only_adv_user",
]);

export const READ_ONLY_ROLES_MAPPING = {
  self_read_only_agc_user: "Agency User - Read Only ",
  self_read_only_adv_user: "Advertiser User - Read Only",
};

export const AGN_GLOBAL_ROLES: ReadonlySet<string> = new Set([
  "agency_primary_admin",
  "agency_admin",
  "agency_api_user",
]);

export const AGN_ADV_ROLES: ReadonlySet<string> = new Set([
  "agency_reporting_user",
  "agency_advertiser_reporting_user",
  "agency_user",
  "managed_agency_user",
  "self_read_only_agc_user",
]);

export const AGN_LVL_ROLES: ReadonlySet<string> = new Set([
  "agency_primary_admin",
  "agency_admin",
  "agency_user",
  "agency_reporting_user",
  "managed_agency_user",
  "self_read_only_agc_user",
]);

export const ROLES_WITH_BALANCE_ACCESS: ReadonlySet<string> = new Set([
  "agency_primary_admin",
  "agency_admin",
  "agency_user",
  "advertiser_primary_admin",
  "advertiser_admin",
  "advertiser_user",
  "managed_advertiser_user",
  "managed_agency_user",
  "self_read_only_adv_user",
  "self_read_only_agc_user",
]);

export const AGN_ADV_LVL_ROLES: ReadonlySet<string> = new Set([
  "agency_advertiser_reporting_user",
]);

export const PLATFORM_ROLES: ReadonlySet<string> = new Set([
  "platform_superadmin",
  "platform_admin",
  "account_manager",
  "platform_account_user",
  "finance_user",
]);

export const ALL_ADV_ROLES: ReadonlySet<string> = new Set([
  "advertiser_primary_admin",
  "advertiser_admin",
  "advertiser_reporting_user",
  "advertiser_user",
  "advertiser_api_user",
  "managed_advertiser_user",
  "self_read_only_adv_user",
]);

export const NON_API_ADV_ROLES: ReadonlySet<string> = new Set([
  "advertiser_primary_admin",
  "advertiser_admin",
  "advertiser_reporting_user",
  "advertiser_user",
  "managed_advertiser_user",
  "self_read_only_adv_user",
]);

export const AGN_ROLES: ReadonlySet<string> = new Set([
  "agency_primary_admin",
  "agency_admin",
  "agency_api_user",
  "agency_reporting_user",
  "agency_advertiser_reporting_user",
  "agency_user",
  "managed_agency_user",
]);

export const PG_DEALS = ["pg_netflix", "pg_others"];

export const APP_ROLE = "outlet_app_user";

export const minImps = 20000;

export const AUDIT_STATUS_TOOL_TIP =
  "Google Adx Audit takes upto 48 hours and user has to revisit to check status.If Google Adx Audit status is Rejected, then ads won’t serve on Google inventory";

export const VIOOH_AUDIT_TOOL_TIP =
  "If VIOOH Audit status is Rejected, then ads won’t serve on VIOOH inventory";

export const XANDR_AUDIT_TOOL_TIP =
  "If Xandr Audit status is Rejected, then ads won’t serve on Xandr inventory";

export const TDSP_XANDR_AUDIT_TOOL_TIP =
  "If platform audit is rejected, ads won't serve on majority of inventory";

export const GOOGLE_INV_INFO_MSG =
  "Creatives will be served on Google Partner Inventory only after creatives pass Google Adx Audit.\
If Google Adx Audit Status is pending or rejected or no audit for any creatives, those creatives will not be served on Google Partner Inventory.";

export const PG_DEAL_TYPES = ["pg_netflix", "pg_others"];

export const entityStates = ["active", "inactive"];

export const NO_OF_LIs_FOR_CREATIVE = "Number of line items using this creative.";

export const MALWARE_SCAN_TOOLTIP = 'This indicates whether the uploaded creative and its landing page have passed automated malware and security checks.';

export const CLICK_TRACKING_TOOLTIP = 'This indicates whether the uploaded creative contains click tracking and can record user clicks.';

export const SHARED_AUDIT_STATUS_OPTIONS = [
  { value: "not_audited", label: "Not Audited" },
  { value: "pending", label: "Pending" },
  { value: "approved", label: "No audit" },
  { value: "rejected", label: "Rejected" },
  { value: "audited", label: "Audited" },
  { value: "unauditable", label: "Unauditable" },
];

export const dspSubPath = {
  vizibl_dsp: {
    ioPath: "/insertion-order",
    ioKey: "insertion_orders",
    liKey: "line_items",
    agcAdvPath: "/agency-advertiser",
    liPath: "/campaign",
    crtvKey: "creatives",
    crtvPath: "/creatives",
  },
  amazon_dsp_us: {
    ioPath: "/adsp/insertion-order",
    ioKey: "adsp_insertion_orders",
    liKey: "adsp_line_items",
    agcAdvPath: "/adsp/agency-advertiser",
    liPath: "/adsp/campaign",
    crtvKey: "adsp_creatives",
    crtvPath: "/adsp/creative",
  },
  amazon_dsp_eu: {
    ioPath: "/adsp/insertion-order",
    ioKey: "adsp_insertion_orders",
    agcAdvPath: "/adsp/agency-advertiser",
    liKey: "adsp_line_items",
    liPath: "/adsp/campaign",
    crtvKey: "adsp_creatives",
    crtvPath: "/adsp/creative",
  },
  beeswax_dsp: {
    ioPath: "/bdsp/insertion-order",
    ioKey: "bdsp_insertion_orders",
    liKey: "bdsp_line_items",
    agcAdvPath: "/bdsp/agency-advertiser",
    liPath: "/bdsp/campaign",
    crtvKey: "bdsp_creatives",
    crtvPath: "/bdsp/creative",
  },
  trade_desk_dsp: {
    ioPath: "/tdsp/insertion-order",
    ioKey: "tdsp_insertion_orders",
    liKey: "tdsp_line_items",
    agcAdvPath: "/tdsp/agency-advertiser",
    liPath: "/tdsp/campaign",
    crtvKey: "tdsp_creatives",
    crtvPath: "/tdsp/creative",
  },
};

export const skipPermission = new Set<any>(["export"]);

export const landingPageActions = [
  {
    value: "deactivate",
    toolTip: "Deactivate",
    icon: "fas fa-toggle-off me-2",
    actionType: "updateState",
  },
  {
    value: "activate",
    toolTip: "Activate",
    icon: "fas fa-toggle-on me-2",
    actionType: "updateState",
  },
  {
    value: "download",
    toolTip: "Download",
    icon: "fas fa-download me-2",
    actionType: "metaDownload",
  },
  {
    value: "bulk_edit",
    toolTip: "Bulk Edit",
    icon: "far fa-edit me-2",
    actionType: "edit",
  },
  {
    value: "bulk_duplicate",
    toolTip: "Bulk Duplicate",
    icon: "far fa-copy me-2",
    actionType: "duplicate",
  },
  {
    value: "update_name",
    toolTip: "Update Name",
    icon: "far fa-edit me-2",
    actionType: "updateName",
  },
  {
    value: "update_flights",
    toolTip: "Bulk update:Flights",
    icon: "far fa-edit me-2",
    actionType: "updateFlights",
  },
];

export const libLandingPageActions = [
  {
    value: "export",
    toolTip: "Export",
    icon: "fas fa-file-export me-2",
    actionType: "export",
  },
  {
    value: "update_name",
    toolTip: "Update Name",
    icon: "far fa-edit me-2",
    actionType: "update-name",
  },
];

export interface TrgtEditAction {
  events_edit_action: "add" | "remove" | "remove_all";
  creatives_edit_action: "add" | "remove" | "remove_all";
  country: "add" | "remove" | "remove_all";
  region: "add" | "remove" | "remove_all";
  city: "add" | "remove" | "remove_all";
  lat_long_list: "add" | "remove" | "remove_all";
  zip: "add" | "remove" | "remove_all";
  domains: "add" | "remove" | "remove_all";
  content_category: "add" | "remove" | "remove_all";
  ads_txt: "add" | "remove" | "remove_all";
  environment_type: "add" | "remove" | "remove_all";
  device: "add" | "remove" | "remove_all";
  operating_system: "add" | "remove" | "remove_all";
  app_bundle: "add" | "remove" | "remove_all";
  segment: "add" | "remove" | "remove_all";
  user_time_of_week: "add" | "remove" | "remove_all";
  native_layout: "add" | "remove" | "remove_all";
  deals: "add" | "remove" | "remove_all";
  player_size: "add" | "remove" | "remove_all";
  start_delay: "add" | "remove" | "remove_all";
  audio_start_delay: "add" | "remove" | "remove_all";
  video_placement_type: "add" | "remove" | "remove_all";
  playback_method: "add" | "remove" | "remove_all";
  language: "add" | "remove" | "remove_all";
  ad_position: "add" | "remove" | "remove_all";
  interstitial_type: "add" | "remove" | "remove_all";
}

export const trgtOperationOptions = [
  {
    label: "Add to existing targeting",
    value: "add",
    toolTip:
      "Selected items will be added to the existing association/targeting list.",
  },
  {
    label: "Remove specific items from existing targeting ",
    value: "remove",
    toolTip:
      "Selected items will be removed from the existing association/targeting list.",
  },
  {
    label: "Remove all from existing targeting",
    value: "remove_all",
    toolTip: "Existing association/targeting list will be removed.",
  },
];

export const BULK_ACTION_MAX_LIMIT = 15;

export const adspPfmMenus = [
  "adsp_libraries_us",
  "adsp_libraries_eu",
  "adsp_reports_us",
  "adsp_reports_eu",
];

export const DEBOUNCE_TIME = 300;

export const bdspPfmMenus = ["bdsp_libraries", "bdsp_reports"];

export const tdspPfmMenus = ["tdsp_libraries", "tdsp_reports"];

export const vdspPfmMenus = ["libraries", "reports"];

export const DEC_PREC_MSG =
  "Values are accepted with a precision of up to two decimal places.";

export const DIGIT_ONLY_MSG = "Decimal Values are not allowed"

export const MARQUEE_DURATION = "7";

export const CRTV_URL_FORMAT =
  "^(https?:\\/\\/)?((([-a-z0-9]{1,63}\\.)*?[a-z0-9]([-a-z0-9]{0,253}[a-z0-9])?\\.[a-z]{2,63})|((\\d{1,3}\\.){3}\\d{1,3}))(:\\d{1,5})?((\\/|\\?)((%[0-9a-f]{2})|[-\\w+\\.\\?\\/@~#&=${}]*)*)?$";

export const GDPR_CONSENT_TAG_MSG =
  "To comply with privacy regulations, the inclusion of privacy signals in URL parameters is mandatory in certain geographical regions, such as the European Economic Area (EEA). Clients must provide either TCF parameters or the consent parameter to ensure personal information is processed correctly, allowing services to function as intended.When working with CMPs that support TCF signals, clients must include the parameters gdpr=1 (when GDPR applies) and gdpr_consent=<CONSENT-STRING> in the respective URLs. These values must be dynamically set based on the customer's privacy choices. If TCF signals are not available, the consent parameter must be used, where 1 indicates customer consent and 0 indicates consent denial.It is the client's responsibility to ensure that these parameters reflect the customer's privacy preferences. Failure to provide the correct signals will prevent the processing of the request and might impact service functionality.";

export const GDPR_CONSENT_WARNING =
  "If the end user site must comply with GDPR consent requirements, the code snippet below needs to be updated to send consent.If the user is in the EU and has not explicitly provided consent, the segment fire will be rejected.";

export function formatNumber(value: any, isCpm: boolean = false): string {
  const num = Number(value);
  if (isNaN(num)) return '0';
  if (num === 0) return '0';

  const format = (n: number, suffix: string = '') => {
    // Format to 3 decimals and remove trailing zeros + decimal if not needed
    return parseFloat(n.toFixed(3)).toString() + suffix;
  };

  if (num >= 1_000_000_000) {
    return format(num / 1_000_000_000, 'B');
  } else if (num >= 1_000_000) {
    return format(num / 1_000_000, 'M');
  } else if (num >= 1_000) {
    return format(num / 1_000, 'K');
  }

  return format(num);
}
